import React from 'react';
import './App.css';

import Routes from './routes'


function App() {

  return(<Routes />);
  /*return (
    <h1>Olá marilene</h1>
    
  );*/
}

export default App;
